var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPasswordSee(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.003,
    height: 19.59,
    viewBox: "0 0 24.003 19.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Password_See",
    "data-name": "Password See",
    d: "M263.649,187.026l-.13-.18a17.854,17.854,0,0,0-2.41-2.85l1.41-2.44a.985.985,0,0,0-.36-1.36,1,1,0,0,0-1.37.36l-1.23,2.129a12.368,12.368,0,0,0-2.28-1.389l.77-2.12a1,1,0,1,0-1.88-.68l-.76,2.08a11.5,11.5,0,0,0-2.41-.44v-2.48a1,1,0,0,0-2,0v2.48a11.409,11.409,0,0,0-2.4.44l-.76-2.08a1.008,1.008,0,0,0-1.29-.6.993.993,0,0,0-.59,1.28l.77,2.12a12.442,12.442,0,0,0-2.29,1.389l-1.23-2.129a1,1,0,0,0-1.73,1l1.41,2.44a18.391,18.391,0,0,0-2.41,2.86l-.13.18a2.033,2.033,0,0,0-.35,1.13,2.065,2.065,0,0,0,.35,1.14l.13.18c3.01,4.36,7.1,6.76,11.52,6.76s8.51-2.4,11.52-6.76l.13-.18a2.02,2.02,0,0,0,0-2.28M252,192.246c-2.75,0-5.38-1.44-7.52-4.08.26-.32.52-.62.79-.9a12.5,12.5,0,0,1,1.09-1,9.475,9.475,0,0,1,1.74-1.17c0-.02.01-.05.01-.07a.138.138,0,0,0,.03.04c-.01.01-.03.02-.04.03a3.573,3.573,0,0,0-.1.87,4,4,0,0,0,8,0,3.573,3.573,0,0,0-.1-.87.076.076,0,0,0-.04-.02.138.138,0,0,0,.03-.04.127.127,0,0,1,.01.06,9.475,9.475,0,0,1,1.74,1.17,12.507,12.507,0,0,1,1.09,1c.27.28.53.58.79.9-2.13,2.64-4.77,4.08-7.52,4.08",
    transform: "translate(-239.999 -176.656)",
    fill: "#B6B7BF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordSee);
export default __webpack_public_path__ + "static/media/PasswordSee.7e9a9104e3a5b6ff80562f567b87c79c.svg";
export { ForwardRef as ReactComponent };